// Utils
import globalLogger, { LoggerComponents } from '../../logger';

// Services
import { refreshPushNotificationsSubscription } from './pushNotificationsManager';

// Selectors
import { isGuestSelector } from '../../user/currentUserSelector';

// Constants
import { NOTIFICATION_PERMISSIONS } from './pushNotificationsConstants';

// Types
import { ReduxState } from '../../types/reduxTypes';

export type PushSubscriptionRequest = () => Promise<void>;

const logger = globalLogger.createChannel(LoggerComponents.SERVICE_WORKER_PUSH_NOTIFICATION_MANAGER);

const isPermissionDeclined = (error: unknown) =>
    error === NOTIFICATION_PERMISSIONS.denied || error === NOTIFICATION_PERMISSIONS.default;

/**
 * Builds the subscribe request external callers share. It never rejects, because neither a Guide
 * CTA nor a console caller has anywhere to attach a rejection handler.
 */
export const createPushSubscriptionRequest =
    (getState: () => ReduxState): PushSubscriptionRequest =>
    async () => {
        // Guests have no account to notify, matching initialisePushSubscription.
        if (isGuestSelector(getState())) return;

        try {
            await refreshPushNotificationsSubscription();
        } catch (error: unknown) {
            if (isPermissionDeclined(error)) return;

            // Sensitive data audit: SAFE — Static failure message plus sanitised error object
            logger.error('Failed to subscribe to push notifications', error);
        }
    };
